import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Input,
  Checkbox,
  Divider,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getSearchApiSearchText } from '../../../network/itemList';
import { getEmployee } from '../../../network/employee';
import TaxesListExpense from './TaxesListExpense';
import ExpensesList from './ExpensesList';
import AdvancesList from './AdvancesList';
import {
  addExpenseClaimSubmit,
  getCompanyInfoClaim,
  getEmployeeAdvanceInfo,
  getExpenseClaimDetailsSubmit,
  updateExpenseClaimSubmit,
} from '../../../network/expenseClaimSubmit';
import HeadingApp from '../../../hooks/HeadingApp';
import { FaMoneyBillTrendUp } from 'react-icons/fa6';
const AddExpenseClaimFinance = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const { companyName } = useSelector((state) => state.user);
  const [setTextAccount, setSetTextAccount] = useState('');
  const [dataSourceTax, setDataSourceTax] = useState([{}]);
  const [dataSourceExpenses, setDataSourceExpenses] = useState([{}]);
  const [dataSourceAdvances, setDataSourceAdvances] = useState([{}]);
  const [amountAdvance, setAmountAdvance] = useState(0);
  // console.log(amountAdvance, 'amountAdvance');

  const [searchTextCostCenter, setSearchTextCostCenter] = useState('');
  const [setTextUsers, setSetTextUsers] = useState('');
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddAdditionalSalay } = useMutation({
    mutationKey: ['addAdditionalSalay'],
    mutationFn: (body) =>
      edit ? updateExpenseClaimSubmit(body, id) : addExpenseClaimSubmit(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getExpenseClaimSubmit] });
      form.resetFields();
      navigate('/expense-claim');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const { data: additionalSalayDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getExpenseClaimSubmit, id],
    queryFn: () => getExpenseClaimDetailsSubmit(id),
    enabled: !!edit,
  });
  const { data: employee } = useQuery({
    queryKey: [queryKeys.getEmployee],
    queryFn: () => getEmployee(),
  });
  const { data: companyInfo } = useQuery({
    queryKey: [queryKeys.getCompanyInfoClaim, companyName],
    queryFn: () => getCompanyInfoClaim(companyName),
  });
  useEffect(() => {
    if (companyInfo?.message && !edit) {
      setDataSourceExpenses(
        dataSourceExpenses.map((item) => ({
          ...item,
          cost_center: companyInfo?.message?.cost_center,
        }))
      );
      form.setFieldsValue({
        payable_account:
          companyInfo?.message?.default_expense_claim_payable_account,
      });
    }
  }, [companyInfo, form]);
  const { mutate: onAdvanceDetails } = useMutation({
    mutationKey: ['getEmployeeAdvanceDetails'],
    mutationFn: (body) => getEmployeeAdvanceInfo(body),
    onSuccess: (data) => {
      console.log(data, 'data');
      setDataSourceAdvances(
        data?.data?.map((item, index) => {
          const paidAmount = Number(item?.paid_amount || 0);
          const returnAmount = Number(item?.return_amount || 0);
          const claimedAmount = Number(item?.claimed_amount || 0);
          return {
            ...item,
            key: index,
            employee_advance: item?.name,
            unclaimed_amount: paidAmount - (returnAmount + claimedAmount),
            advance_paid: paidAmount,
            allocated_amount: paidAmount - (returnAmount + claimedAmount),
          };
        }) || []
      );
      // setDataSourceAdvances(data?.data?.map((item) => ({
      //    ...item,
      //    employee_advance: item?.name,
      //    unclaimed_amount: Number(item?.paid_amount - (item?.return_amount + item?.calimed_amount)),
      //    advance_paid: item?.paid_amount,
      //    allocated_amount:Number(item?.paid_amount) - Number((item?.return_amount + item?.calimed_amount))
      // })) || []);
    },
  });
  useEffect(() => {
    if (dataSourceExpenses && !edit) {
      const totalAmount = dataSourceExpenses.reduce(
        (acc, item) => acc + Number(item?.amount),
        0
      );
      setAmountAdvance(totalAmount);
    }
  }, [dataSourceExpenses]);
  // const { data: costCenters } = useQuery({
  //   queryKey: [queryKeys.getCostCentersSearch,searchTextCostCenter],
  //   queryFn: () => getSearchApiSearchText({type:'Cost Center',searchTxt:searchTextCostCenter}),
  //   keepPreviousData: true,
  // });
  const { data: accounts } = useQuery({
    queryKey: [queryKeys.getAccountSearch, setTextAccount],
    queryFn: () =>
      getSearchApiSearchText({ type: 'Account', searchTxt: setTextAccount }),
    keepPreviousData: true,
  });
  const { data: users } = useQuery({
    queryKey: [queryKeys.getSearchUser, setTextUsers],
    queryFn: () =>
      getSearchApiSearchText({ type: 'User', searchTxt: setTextUsers }),
    keepPreviousData: true,
  });
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddAdditionalSalay({
      ...values,
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      taxes: dataSourceTax[0]?.account_head ? dataSourceTax : [],
      expenses: dataSourceExpenses,
      advances: dataSourceAdvances?.map((item) => ({
        ...item,
        allocated_amount: Number(item?.allocated_amount || 0),
      })),
    });
  };
  useEffect(() => {
    if (edit && additionalSalayDetails) {
      setDataSourceTax(additionalSalayDetails?.data?.taxes || [{}]);
      setDataSourceExpenses(additionalSalayDetails?.data?.expenses || [{}]);
      setDataSourceAdvances(
        additionalSalayDetails?.data?.advances?.map((item, index) => ({
          ...item,
          key: index,
        })) || [{}]
      );
      form.setFieldsValue({
        ...additionalSalayDetails?.data,
        posting_date: dayjs(additionalSalayDetails?.data?.posting_date),
      });
    } else {
      form.resetFields();
    }
  }, [edit, additionalSalayDetails, form]);
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.HR}
        subTitle={edit ? t.EditExpenseClaim : t.AddExpenseClaim}
        path="/expense-claim"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.expenseClaim}
        subTitle={edit ? t.EditExpenseClaim : t.AddExpenseClaim}
        icon={<FaMoneyBillTrendUp />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-additional-salay"
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: '20px' }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee"
                    label={t.Employee}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Employee}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      onChange={(value, option) => {
                        console.log(option, 'option');
                        onAdvanceDetails({ employee: value });
                        form.setFieldsValue({
                          employee_name: option?.option?.employee_name,
                          department: option?.option?.department,
                        });
                      }}
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={employee?.data?.map((user) => ({
                        value: user.name,
                        label: user.name,
                        option: user,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee_name"
                    label={t.employeeName}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.employeeName} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="department" label={t.department}>
                    <Input placeholder={t.department} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="expense_approver" label={t.expenseApprover}>
                    {/* <Input placeholder={t.expenseApprover}   /> */}
                    <Select
                      placeholder={t.expenseApprover}
                      popupMatchSelectWidth={false}
                      showSearch
                      filterOption={false}
                      onSearch={(value) => {
                        setSetTextUsers(value);
                      }}
                      options={users?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="approval_status"
                    label={t.approvalStatus}
                    rules={[{ required: true }]}
                    initialValue={'Approved'}
                  >
                    <Select
                      placeholder={t.approvalStatus}
                      defaultValue="Approved"
                    >
                      <Select.Option value="Draft">{t.draft}</Select.Option>
                      <Select.Option value="Approved">
                        {t.approved}
                      </Select.Option>
                      <Select.Option value="Rejected">
                        {t.rejected}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[{ required: true }]}
                    initialValue={dayjs()}
                    style={{ width: '100%' }}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.postingDate}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="payable_account"
                    label={t.payableAccount}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.payableAccount}
                      popupMatchSelectWidth={false}
                      showSearch
                      filterOption={false}
                      onSearch={(value) => {
                        setSetTextAccount(value);
                      }}
                      options={accounts?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    // justifyContent: 'flex-start',
                  }}
                >
                  <Form.Item
                    name="is_paid"
                    valuePropName="checked"
                    className="margin-bottom-0"
                    // style={{
                    //   display: 'flex',
                    //   alignItems: 'center',
                    //   justifyContent: 'flex-start',
                    // }}
                  >
                    <Checkbox>{t.isPaid}</Checkbox>
                  </Form.Item>
                </Col>

                <Divider orientation="left">{t.expenses}</Divider>
                <Col span={24}>
                  <ExpensesList
                    setDataSourceExpenses={setDataSourceExpenses}
                    dataSourceExpenses={dataSourceExpenses}
                    costCenterData={companyInfo?.message?.cost_center}
                    t={t}
                    form={form}
                  />
                </Col>
                <Divider orientation="left">{t.taxes}</Divider>
                <Col span={24}>
                  <TaxesListExpense
                    setDataSourceAdvances={setDataSourceAdvances}
                    dataSourceExpenses={dataSourceExpenses}
                    setDataSourceTax={setDataSourceTax}
                    dataSourceTax={dataSourceTax}
                    t={t}
                    form={form}
                  />
                </Col>
                <Divider orientation="left">{t.advances}</Divider>
                <Col span={24}>
                  <AdvancesList
                    edit={edit}
                    amountAdvance={amountAdvance}
                    dataSourceTax={dataSourceTax}
                    setDataSourceAdvances={setDataSourceAdvances}
                    dataSourceAdvances={dataSourceAdvances}
                    t={t}
                    form={form}
                  />
                </Col>
              </Row>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => navigate(-1)}>
                  {t.cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddExpenseClaimFinance;
